import createSvgIcon from '../Utils/CreateSvgIcon';

export const CheckCircle = createSvgIcon(
  <>
    <path
      d="M22 34L28 40L42 26"
      stroke="#021727"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z"
      stroke="#021727"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </>,
  'CheckCircle',
  '0 0 64 64',
);
